import script from "./Thought.vue?vue&type=script&setup=true&lang=ts"
export * from "./Thought.vue?vue&type=script&setup=true&lang=ts"

import "./Thought.vue?vue&type=style&index=0&id=46974028&lang=css"

const __exports__ = script;

export default __exports__